
import { post,get } from '../utils/http';

export function userLogin(param) {
    return post('v1/admin/user/email/login', param);
}

export function getProfile(param) {
    return get('v1/admin/user/profile', param);
}